import { DashboardWidgetDefinition } from 'src/app/shared/dashboard-grid';
import { AccessControl } from 'src/app/shared/authentication/access-control';

/** The widgets, each also requiring `feature`; the user sees and adds only the widgets of features they have. */
export function gatedByFeature<const W extends readonly DashboardWidgetDefinition[]>(feature: string, widgets: W): W {
  return widgets.map((widget) => ({
    ...widget,
    permissions: [feature, ...(widget.permissions ?? [])],
  })) as unknown as W;
}

const ENTERPRISE_WIDGETS = [] as const;

/** Every widget the dashboard registers; each feature contributes its own set to the one dashboard. */
export const DASHBOARD_WIDGETS = [
  ...gatedByFeature(AccessControl.FeatureEnterpriseDashboard, ENTERPRISE_WIDGETS),
] as const;
